// "Open / close every group": the one expand button of the product, a quiet violet icon button with a tooltip, in place of the
// old "Udfold / Sammenfold" text. Used on every list and side panel made of foldable groups.
import React from 'react';
import './DetailPanel.css';

export default function ExpandAll({ allOpen, onClick, label: custom }) {
  const label = custom || (allOpen ? 'Luk alle grupper' : 'Åbn alle grupper');
  return (
    <button type="button" className="dp-expand" onClick={onClick} aria-label={label} title={label}>
      {/* two arrows: pointing down opens every group, pointing up closes them */}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {allOpen ? <path d="M7 16l5-5 5 5M7 10l5-5 5 5" /> : <path d="M7 8l5 5 5-5M7 14l5 5 5-5" />}
      </svg>
    </button>
  );
}
